import React from 'react';

/**
 * Marks a capability that is committed but not yet shipped.
 *
 * The site's credibility rests on the reader being able to tell the difference
 * between what they can use on the day they order and what is coming, so every
 * unbuilt claim on the marketing site carries one of these. The text is
 * announced to screen readers as part of the surrounding heading.
 */
const StatusTag = ({ children = 'In development' }) => (
  <span className="vxm-tag">{children}</span>
);

export default StatusTag;
